import type { Lang } from "@/langs";
import { renderLocaleContent } from "../_utils/render-locale-content";
import dictionary from "./t-glob.json";

export function tGlob(
  key: keyof typeof dictionary,
  lang: Lang,
  isStringOnly: true,
  dynamicTexts?: Record<string, string>,
): string;
export function tGlob(
  key: keyof typeof dictionary,
  lang: Lang,
  isStringOnly?: boolean,
  dynamicTexts?: Record<string, string>,
): string | React.ReactElement;
export function tGlob(
  key: keyof typeof dictionary,
  lang: Lang,
  isStringOnly?: boolean,
  dynamicTexts?: Record<string, string>,
): string | React.ReactElement {
  return renderLocaleContent(dictionary, key, lang, isStringOnly, dynamicTexts);
}
